import React from 'react'
import RatingByCategory from '../RatingByCategory'
import { Container } from '../../styles/global'
import {
  EachRating,
  RatingAverage,
  Subtitle,
  Text
} from './styles'

const Ratings = () => {
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const pointToComma = number => number.replace('.', ',')

  const renderRating = (average = '0') => {
    return (
      <>
        <Text>{
          average === '0'
            ? 'Sem avaliações'
            : <>Sua nota atual é <strong>{pointToComma(average)}/5</strong></>
        }
        </Text>
        <RatingAverage>
          <EachRating>
            <RatingByCategory category="Pontualidade" rating={professional.punctualityRating || 0} />
            <RatingByCategory category="Qualidade do serviço" rating={professional.qualityOfServicesProvidedRating || 0} />
            <RatingByCategory category="Disponibilidade de agenda" rating={professional.scheduleAvailabilityRating || 0} />
          </EachRating>
        </RatingAverage>
      </>
    )
  }

  return (
    <Container>
      <Subtitle>Avaliações dos clientes de {professional.name}</Subtitle>
      {renderRating(professional.ratingAverage)}
    </Container>
  )
}

export default Ratings
